import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import { ReceiptLongOutlined, ShowChartOutlined } from '@mui/icons-material';
import TransactionAnalysis from './TransactionAnalysis';
import InvestmentAnalysis from './InvestmentAnalysis';

// /analysis (Transactions tab) and /analysis?view=investments (Investments tab)
const Analysis = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const view = searchParams.get('view') === 'investments' ? 'investments' : 'transactions';

  // Each tab keeps its own filters; switching tabs starts the other one fresh
  const changeView = (event, value) => setSearchParams(value === 'investments' ? { view: 'investments' } : {}, { replace: false });

  return (
    <Box sx={{ p: { xs: 2, sm: 3 } }}>
      <Typography variant="h4" sx={{ fontWeight: 700 }}>Analysis</Typography>
      <Tabs value={view} onChange={changeView} data-tour="analysis-tabs" sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
        <Tab value="transactions" label="Transactions" icon={<ReceiptLongOutlined fontSize="small" />} iconPosition="start" />
        <Tab value="investments" label="Investments" icon={<ShowChartOutlined fontSize="small" />} iconPosition="start" />
      </Tabs>
      {view === 'investments' ? <InvestmentAnalysis key="investments" /> : <TransactionAnalysis key="transactions" />}
    </Box>
  );
};

export default Analysis;
